import {all, take, cancel} from "redux-saga/effects";
import {combineReducers} from "redux";
import * as auth from "../app/modules/Auth/redux/reducer";
// import * as auth from "../app/modules/Auth/redux/reducer";
import saga from "./rootSaga";
import {customersSlice} from "../app/modules/ECommerce/_redux/customers/customersSlice";
import {productsSlice} from "../app/modules/ECommerce/_redux/products/productsSlice";
import {remarksSlice} from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import {specificationsSlice} from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";
import {actionTypes} from "../app/modules/Auth/redux/actions";
import * as customerMessage from "../app/modules/CustomerMessage/redux/reducer";


export const rootReducer = combineReducers({
  auth: auth.reducer,
  customerMessage: customerMessage.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer
});

export function* rootSaga() {
  const allTask = yield all([saga]);

  yield take(actionTypes.Logout);
  yield cancel(allTask);
}
